import React, { useContext } from 'react'

import cx from 'classnames'

import { A, CircleLoader } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import { CompanyDetailsContext } from 'context/companyDetails'

import BaseCard from '../BaseCard'
import { CardHeader,CardHeaderExpandProps } from '../CardHeader'
import { MemoReadonlyField } from '../Fields'

import { useSalesforceAccountData } from './api'

import utilityStyles from '../../../styles/utility.module.css'
import styles from './styles.module.css'

export const SFDCHeader: React.FC<CardHeaderExpandProps> = ({ ...rest }) => (
  <CardHeader content="Salesforce" data-ocweb-id="SFDCAccountCardHeader" {...rest} />
)

export const SFDCCard: React.FC = () => {
  const { companyData } = useContext(CompanyDetailsContext)

  const { data: sfdcData, error } = useSalesforceAccountData({
    accountDomain: companyData?.domain
  })

  const isLoading = !sfdcData && !error
  if (isLoading) {
    return (
      <div className={styles.loading}>
        <CircleLoader />
      </div>
    )
  }

  return (
    <BaseCard data-ocweb-id="SFDCAccountCard">
      {isLoading && (
        <div className={styles.loading}>
          <CircleLoader />
        </div>
      )}

      {!isLoading && error && error?.response?.status !== 404 && (
        <div
          data-ocweb-id="SFDCAccountCardError"
          className={cx(utilityStyles.smFontSize, styles.errorMessage)}>
          {"We couldn't load data from Salesforce."}
        </div>
      )}

      {!isLoading && error?.response?.status === 404 && (
        <div
          data-ocweb-id="SFDCAccountCardNotFound"
          className={cx(utilityStyles.smFontSize, styles.errorMessage)}>
          {`We couldn't find this account in Salesforce.`}
        </div>
      )}
      {!isLoading && sfdcData && sfdcData.accounts && sfdcData.accounts.length > 0 && (
        <>
          <div className={styles.fields}>
            <MemoReadonlyField
              key={'name'}
              label={'Account name'}
              value={sfdcData?.accounts?.[0]?.Name ?? '-'}
            />
            <MemoReadonlyField
              key={'website'}
              label={'Website'}
              value={companyData?.domain ?? '-'}
            />
            <MemoReadonlyField
              key={'owner'}
              label={'Account owner'}
              value={sfdcData?.accounts?.[0]?.Owner?.Name ?? '-'}
            />
            <MemoReadonlyField
              key={'stage'}
              label={'Opportunity stage'}
              value={sfdcData?.opportunities?.[0]?.StageName ?? '-'}
            />
            <MemoReadonlyField
              key={'industry'}
              label={'Industry'}
              value={sfdcData?.accounts?.[0]?.Industry ?? '-'}
            />
          </div>

          {sfdcData?.baseUrl && (
            <div>
              <A
                className={styles.openInSalesforce}
                href={`${sfdcData.baseUrl}/${sfdcData.accounts[0].Id}`}
                target="_blank"
                rel="noreferrer noopener"
                data-ocweb-id="ViewAccountInSalesforceLink">
                {'View in Salesforce '}
                <Icon
                  name="open-new-tab"
                  width={12}
                  height={12}
                  className={styles.openInSalesforceIcon}
                />
              </A>
            </div>
          )}
        </>
      )}
    </BaseCard>
  )
}
